import { render, staticRenderFns } from "./CompareTable.vue?vue&type=template&id=3f8f964f"
import script from "./CompareTable.vue?vue&type=script&lang=ts"
export * from "./CompareTable.vue?vue&type=script&lang=ts"
import style0 from "./CompareTable.vue?vue&type=style&index=0&id=3f8f964f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports